export const EnumProducts = {
    PRODUCT: "product",
    TEMP_PRODUCT: "temp_product",
};

export const EnumContext = {
    COLLECTION: "collection",
    WISHLIST: "wishlist",
};
